<template>
  <div class="ic-form__k-04">
    <FormWrapper :validator="$v.form">
      <IcFormContactEmail v-model="form.email" />

      <IcFormRowWrapper
        id="url"
        name="url"
        :label="$t('label_url')"
        :aria="$t('aria_required')"
        :labelWidth="4"
        :controlWidth="8"
        :showSingleError="true"
      >
        <template slot-scope="{validator}">
          <IcInput id="url" autocomplete="url" v-model="form.url" @input="$emit('input', $event); validator.$touch()"></IcInput>
        </template>
      </IcFormRowWrapper>

      <IcFormContactMessage v-model="form.message" />
      <IcFormContactFiles v-model="form.files" />
      <IcFormAgreements v-model="form.agreement" :text="false" :header="false" :modal="true" name="agreement"
              :label="$t('label_agreement_checkbox')" content="form_agreement_k">
      </IcFormAgreements>

      <IcFormButtons @click="submit" :sending="isSending" :error="isError" :message="errorMessage" />
    </FormWrapper>
  </div>
</template>

<script>
import IcFormContactK01 from "@/components/ic/form/contact/k_01";

import IcInput from "@/components/ic-common/form/controls/Input";
import validations from "./Validation/k_04.js";
export default {
  extends: IcFormContactK01,
  name: "IcFormContactK04",
  validations,
  data() {
    return {
      form: {
        type: "k04",
        
      }
    };
  },
  components: {
    IcInput
  }
};
</script>

<style>
</style>
